import styled from 'styled-components';

export const Content = styled.div`
  .btn-long-text {
    height: 17px;
    line-height: 14px;
    margin-top: -2px;
    width: 17px;
  }
`;
